import React from 'react'
import {t} from '../../lib/localize'

export default function SubmitButton ({label, enabled=true, onClick}) {
  label = label || t('button.ok')
  const css = enabled ? 'enabled' : 'disabled'
  return <button type='submit'
                 className={`button primary ${css}`}
                 onClick={onClick}>{label}</button>
}